module.exports = __webpack_public_path__ + "static/eSports-15cf00726001a87881d5f7c8f740411b.png";